
<template>
  <v-card 
    class="card"
    @mouseover="showDelete = enableDelete ? true : false"
    @mouseout="showDelete = false"
  >

    <custom-market-renamer
      :show="showCustomMarketRenamer"
      :market="selectedMarket.market"
      v-on:did-apply="saveCustomMarket"
      v-on:close-dialog="showCustomMarketRenamer=false"
    >
    </custom-market-renamer>

    <v-btn
      absolute
      flat
      color="red lighten-2"
      small
      class="delete-card-button"
      v-show="showDelete"
      @click="deleteCard"
    >
    DELETE
    </v-btn>

    <v-btn
      absolute
      icon
      @click="showCustomMarketRenamer=true" 
      class="edit-name-button"
    >
      <v-icon>edit</v-icon>
    </v-btn>

    <v-select
      :items="marketList"
      :value="selectedMarketName"
      :label="selectLabel"
      class="ma-0 pl-3 pr-3 pt-4 market-name"
      v-show="!isEditedCustomMarket"
      v-on:change="selectedMarketDidChange"
    ></v-select>
    
    <div 
      class="ma-0 pl-3 pr-3 pt-4 market-name text-xs-left"
      v-show="isEditedCustomMarket"
    >
      {{ selectedMarketName }}
    </div>

    <div class="total-cost pr-2">
      <div class="label">TOTAL COST</div>
      <div class="value">{{ totalCost }}</div>
    </div>

    <div class="subtotal-block">
      <div class="subtotal-cost pr-2">
        <div class="label">REAL ESTATE</div>
        <div class="value">{{ realEstateCost }}</div>
      </div>
      <div class="subtotal-cost pr-2">
        <div class="label">LABOR</div>
        <div class="value">{{ laborCost }}</div>
      </div>
      <div class="subtotal-cost pr-2">
        <div class="label">TRANSPORTATION</div>
        <div class="value">{{ transportationCost }}</div>
      </div>
    </div>
  </v-card>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'market-costs-card',
  data () {
    return {
      showDelete: false,
      showCustomMarketRenamer: false,
      internalMarkets: [ ]
    }
  },

  props: {    
    ident: String,
    markets: Array,
    selectedMarket: Object,
    enableDelete: Boolean,
    randomId: String,
    customMarket: Object
  },
  
  beforeMount: function(){
    this.internalMarkets = _.cloneDeep(this.markets)
    this.internalMarkets.forEach(m => {
      m.id = m.id == 0 ? this.randomId : m.id
    })
  },
  
  watch: {
    randomId() {
      this.internalMarkets.forEach(m => {
        if(m.id.indexOf("0_") == 0){
          m.id = this.randomId
        }
      })
    },
    customMarket() {
      this.internalMarkets = this.internalMarkets.map(m => {
        if(m.id.indexOf("0_") == 0){
          return this.customMarket
        }
        return m
      });
    }
  },

  methods: {
    numberWithCommas(x) {
      return Number(x).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    deleteCard() {
      this.$emit('delete-card')
    },
    randomNumber(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    },
    selectedMarketDidChange(ev) {
      let market = this.internalMarkets.find(o => o.name === ev)
      // if the market isn't found, then it must be a renamed custom market.
      // we can just bail since custom markets cannot be changed apart from the initial set.
      if(typeof market == "undefined"){
        return;
      }
      const marketsToCompare = this.$store.getters.marketsToCompare.map(m => m.market.name).filter(m => m !== 'Add a Custom Market');
      if(marketsToCompare.includes(market.name)){
        let cloneMarket = Object.assign({}, market);
        const _id = this.randomNumber(8000, 10000).toString();
        cloneMarket.id = _id;
        // console.log(market);
        // console.log(cloneMarket);
        // console.log('ident:' + this.ident.toString())
        this.$emit('selected-market-did-change', { ident: this.ident, market: cloneMarket })
        return;
      }
      this.$emit('selected-market-did-change', { ident: this.ident, market: market })
    },
    saveCustomMarket(editedMarket) {
      let customMarket;
      let isStandardMarketRename = false
      
      if(this.selectedMarketId > 0){
        customMarket = _.cloneDeep(this.selectedMarket.market)
        customMarket.name = editedMarket.name
        customMarket.id = this.randomId
        customMarket.latitude = editedMarket.geocodedData.latitude
        customMarket.longitude = editedMarket.geocodedData.longitude
        if(editedMarket.geocodedData.city || editedMarket.geocodedData.state){
          customMarket.city = editedMarket.geocodedData.city
          customMarket.state = editedMarket.geocodedData.state
        }
        isStandardMarketRename = true
      } else {
        this.internalMarkets.forEach(m => {
          if(m.id.indexOf("0_") == 0){
            m.name = editedMarket.name
            m.latitude = editedMarket.geocodedData.latitude
            m.longitude = editedMarket.geocodedData.longitude
            m.city = editedMarket.geocodedData.city
            m.state = editedMarket.geocodedData.state
            customMarket = m
          }
        });
      }
      customMarket.locationString = editedMarket.locationString
      
      this.$emit('selected-market-did-change', { 
        ident: this.ident, 
        market: customMarket, 
        isStandardMarketRename: isStandardMarketRename, 
        costPerContainerAtNearestPort: editedMarket.geocodedData.costPerContainerAtNearestPort
      })
    }
  },

  computed: {
    selectLabel() {
      let selectLabel = '';
      const _selectedMarket = this.selectedMarket && this.selectedMarket.market ? this.selectedMarket.market.name : '';
      if(_selectedMarket !== '') {
        selectLabel = _selectedMarket;
      }
      if (_selectedMarket === 'Add a Custom Market') {
        selectLabel = 'Select a Location';
      }
      return selectLabel;
    },
    marketList() {
      // const marketsToCompare = this.$store.getters.marketsToCompare.map(m => m.market.name).filter(m => m !== 'Add a Custom Market');
      // console.log(marketsToCompare);
      let marketList = this.internalMarkets.map(m => m.name);
      // marketList = marketList.filter(m => !marketsToCompare.includes(m));
      return marketList;
    },
    totalCost() {
      return this.selectedMarket && this.selectedMarket.totalCost ? `$${this.numberWithCommas(this.selectedMarket ? this.selectedMarket.totalCost || 0 : 0)}` : '?'
    },
    realEstateCost() {
      return this.selectedMarket && this.selectedMarket.realEstateCost ? `$${this.numberWithCommas(this.selectedMarket ? this.selectedMarket.realEstateCost || 0 : 0)}` : '?'
    },
    isCustomMarket() {
      return this.selectedMarket && this.selectedMarket.market ? this.selectedMarketId.indexOf("0_") == 0 : false
    },
    isEditedCustomMarket() {
      return this.isCustomMarket ? this.selectedMarket.market.name.toLowerCase() != "add a custom market" : false
    },
    laborCost() {
      return this.selectedMarket && this.selectedMarket.laborCost ? `$${this.numberWithCommas(this.selectedMarket ? this.selectedMarket.laborCost || 0 : 0)}` : '?'
    },
    transportationCost() {
      return this.selectedMarket && this.selectedMarket.transportationCost ? `$${this.numberWithCommas(this.selectedMarket ? this.selectedMarket.transportationCost || 0 : 0)}` : '?'
    },
    selectedMarketName() {
      return this.selectedMarket && this.selectedMarket.market ? this.selectedMarket.market.name : ''
    },
    selectedMarketId() {
      return this.selectedMarket && this.selectedMarket.market ? this.selectedMarket.market.id : -1
    }
  },
  
  components: {
    'custom-market-renamer': () => import ('@/components/CustomMarketRenamer')
  }
}

</script>


<style scoped>
.card {
  height: 120px; 
  width: 100%;
}
.card:hover {
  background-color: #f8f8f8;
}

.delete-card-button {
  left: 5px;
  bottom: 10px;
  z-index: 10;
}
.edit-name-button {
  right:33%;
  top: 20px;
  z-index: 10;
}
.total-cost {
  text-align: right;
  line-height: 12pt;
  position: absolute;
  top: 10px;
  right: 5px;
}
.total-cost .label {
  display: inline-block;
  font-size: 9pt;
  font-style: italic;
  color: darkgrey;
  text-align: right;
}
.total-cost .value {
  font-size: 12pt;
  font-weight: 800;
}

.subtotal-block {
  position: absolute;
  top: 65px;
  right: 5px;
  width: 100%;
}
.subtotal-cost {
  text-align: right;
  line-height: 12pt;
}
.subtotal-cost .label {
  position: absolute;
  display: inline-block;
  font-size: 8pt;
  font-style: italic;
  color: darkgrey;
  text-align: right;
  right: 130px;
}
.subtotal-cost .value {
  position: relative;
  font-size: 10pt;
  font-weight: 400;
}
.market-name {
  width: 60%;
}

</style>